const isVideoMetadata = (obj) => {
  return typeof obj === "object" && obj !== null && (obj.title !== void 0 || obj.thumbnail_url !== void 0 || obj.thumbnail_width !== void 0 || obj.thumbnail_height !== void 0);
};
export {
  isVideoMetadata
};
//# sourceMappingURL=is-video-metadata.js.map
